var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.validUrl)?_c('v-img',{class:_vm.className,attrs:{"src":_vm.validUrl,"width":_vm.width,"height":_vm.height},on:{"error":_vm.onImageError}}):_c('no-image',{attrs:{"width":_vm.width,"height":_vm.height}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }